import {
  call,
  put, select,
} from 'redux-saga/effects'

import createTrackingMeta from '@doveconviene/sf-web-js-sdk/createTrackingMeta'
import { tracking as trackingActions } from 'flux/actions'
import {
  application as applicationSelectors,
  tracking as trackingSelectors,
  property as propertySelectors,
  router as routerSelectors,
  ui as uiSelectors,
  flyers as flyersSelectors,
  user as userSelectors,
} from 'flux/selectors'

import { getI18nMap } from 'utils/i18n'
import qs from 'qs'
import UAParser from 'ua-parser-js'
import { v5 as uuidv5 } from 'uuid'
import fingerprintjs from '@fingerprintjs/fingerprintjs'
import { webStorage } from 'utils'


const fingerprintStorageKey = 'fingerprint'
const ua = UAParser()

const password = process.env.REACT_APP_SPLUNK_PASSWORD

async function generateUuid() {
  const promiseAgent = await fingerprintjs.load()
  const result = await promiseAgent.get({
    debug: process.env.NODE_ENV === 'development',
  })

  return uuidv5(result.visitorId, this.uuidNamespace)
}

function* getFingerprint() {
  // check fingerPrint into url (muid)
  const muid = yield select(userSelectors.selectUserId)
  if (muid) return muid

  // check fingerPrint into LocalStorage
  let userFingerprint = webStorage.getItem(fingerprintStorageKey)
  if (userFingerprint) return userFingerprint

  // generate fingerPrint
  userFingerprint = yield call(generateUuid)
  webStorage.setItem(this.storageKey, userFingerprint)

  return userFingerprint
}

function* getHeaderPayload(routerQuery) {
  const propertyId = yield select(propertySelectors.selectPropertyId)  
  const language = yield select(uiSelectors.selectLanguage)
  const country = getI18nMap(language).ISO3166_1
  const uid = yield getFingerprint()

  const h = {
    brn: ua.browser.name,
    brv: ua.browser.version,
    ct: country,
    pid: propertyId,
    pn: 'viewer-whitelabel',
    sn: ua.os.name,
    sv: ua.os.version,
    tp: routerQuery.t,
    uid,
  }
  return h
}

function sendPayload(et, st, entries) {
  const { REACT_APP_SPLUNK_URL } = process.env

  return fetch(`${REACT_APP_SPLUNK_URL}/?${qs.stringify({ et, st })}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: JSON.stringify(entries),
  })
}

export function* trackGclid(profilingConsent) {
  const flyerId = yield select(flyersSelectors.selectCurrentFlyerId)
  const { lat, lng } = yield select(trackingSelectors.selectTrackingGeolocation)
  const extras = yield select(propertySelectors.selectPropertyExtras)
  const { web_network: webNetworkInfo = { active: '0' } } = extras

  const routerQuery = yield select(routerSelectors.selectRouterQuery)
  const { utm_source: utmSourceFromQuery } = routerQuery || {}
  const utmSourceFromWebNetwork = webNetworkInfo && webNetworkInfo.active === '1' && webNetworkInfo.utm_source
  const utm_source = utmSourceFromWebNetwork || utmSourceFromQuery || 'direct'

  const { ts, et, st } = createTrackingMeta(password)

  const header = yield getHeaderPayload(routerQuery)

  const gclid = yield select(applicationSelectors.selectGclid)

  const payload = {
    h: header,
    v: '1.0',
    e: [{
      at: {
        utms: utm_source,
        utmm: '',
        utmc: '',
        fid: flyerId,
        lat,
        lng,
        sf_action: 'FlyerOpen',
        conversion_id: gclid,
        utm_source,
        sf_resource_type: 'flyer',
        sf_resource_id: flyerId,
        profiling_consent: profilingConsent,
        landing_url: window?.location?.href,
      },
      et: 'external_conversion',
      ts,
    }],
  }

  try {
    sendPayload(et, st, payload)
  } catch (e) {
    yield put(trackingActions.trackingError(e, 'trackGclid'))
  }
}
